<template>
    <div class="table-tools-actions flex justify-center md:justify-end w-full md:w-auto  items-center space-x-2 select-none">
    <!-- <div class="table-tools-actions flex justify-center md:justify-end w-full items-center space-x-2 select-none"> -->
  <!--    <base-input-search  @keydown="actionSearch" v-model="search" name="search" size="xs" type="text" @manualSearch="manualSearch" /> -->
      <base-button @click="toggleFilters" size="xs" class="w-full md:w-auto" text="Filtros"></base-button>
    </div>
</template>

<script>
export default {
  name: 'base-table-search',
  data: function () {
    return {
      search: ''
    }
  },
  methods: {
    toggleFilters: function () {
      this.$emit('toggleFilters')
    },
    actionSearch: function () {
      // busqueda según escribe
    },
    manualSearch: function (val) {
      // busqueda tras enter o pulsar el botón de buscar del input
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
